import _pt from "prop-types";
import "core-js/modules/es.regexp.constructor.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.function.bind.js";
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { IconSearch } from '@lmig/lmds-react-icons';
import React from 'react';
import { AlphanumericInput } from '../AlphanumericInput';

// We duplicate the AlphanumericInput props here to ensure that those props are listed in props.json.
// Possibly related: https://github.com/reactjs/react-docgen/issues/366
export var SearchInput = function SearchInput(props) {
  return /*#__PURE__*/React.createElement(AlphanumericInput, _extends({}, props, {
    type: "search",
    icon: /*#__PURE__*/React.createElement(IconSearch, null),
    isClearable: true
  }));
};
SearchInput.propTypes = {
  /** Add an optional ID to this element: `<input className="lm-Field-input">`. */id: _pt.string,
  /** Add custom classes to this element: `<input className="lm-Field-input">`. */className: _pt.string,
  /** Used for POST and GET if using the browser’s native form submission functionality. */name: _pt.string,
  /** The value that displays in the input field. If using a masked field type, a raw value is acceptable. */value: _pt.string,
  /** Block users from interacting with this field.
     * @default false
     */
  disabled: _pt.bool,
  /** The text that appears inside the input field and becomes a floating label when focused. */labelVisual: _pt.node.isRequired,
  /** Used with screen readers, optional?: this text will replace the labelVisual in audio guidance. */labelA11y: _pt.node,
  /** Additional text to display near the field. */helpText: _pt.node,
  /** Apply situational colors and behaviors to this element. */highlightType: _pt.oneOf(['error']),
  /** If using a mask, you can optionally specify how the text is concealed.
     * By default (i.e., when value is undefined) the most common concealment for the given mask type will be used.
     * Remove concealing by using the 'none' value. */
  conceal: _pt.oneOf(['all', 'allButLastFour', 'email', 'lastFour', 'none']),
  /** Pass a regular expression to prevent entry of specific characters, by default all characters are allowed.
     * @default .*
     */
  filter: _pt.instanceOf(RegExp),
  /* Add placeholder text to be displayed on focus. If using a mask, this will override the default mask placeholder. */placeholder: _pt.string,
  /** Whether the component is in a loading state.
     * @default false
     */
  loading: _pt.bool,
  /** Pass additional functionality to run on onKeyDown events. */onKeyDown: _pt.func,
  /** Pass additional functionality to run on click events. */onClick: _pt.func,
  /** Pass additional functionality to run on change events. */onChange: _pt.func,
  /** Pass additional functionality to run on blur events. */onBlur: _pt.func,
  /** Pass additional functionality to run on focus events. */onFocus: _pt.func,
  /** Pass additional functionality to run for click events on the Clear button. */onClearClicked: _pt.func,
  /** A ref which will be attached to the `<input />` element to manage focus, values, etc. */innerRef: _pt.oneOfType([_pt.string, _pt.func, _pt.object]),
  /** Render optional action buttons inside `<span class="lm-Field-actionButton">` via children. */children: _pt.node
};